<template>
  <div>
    <span v-translate>{{ label }}</span>
    <link-component :name="name" :params="params">
      <slot></slot>
    </link-component>
  </div>
</template>
<script>
  import LinkComponent from '@/components/layout/utility/LinkComponent'

  export default {
    name: 'link-grid-component',
    components: {
      LinkComponent
    },
    props: {
      label: {
        type: String,
        default: ''
      },
      name: {
        type: String,
        required: true
      },
      params: {
        type: Object,
        required: true
      }
    }
  }
</script>
